export const GET_ALL_LEAD = "GET_ALL_LEAD";
export const GET_ALL_LEAD_SUCCESS = "GET_ALL_LEAD_SUCCESS";
export const GET_ALL_LEAD_CATEGORY = "GET_ALL_LEAD_CATEGORY";
export const ADD_LEAD_ITEM = "ADD_LEAD_ITEM";
export const UPDATE_LEAD_ITEM = "UPDATE_LEAD_ITEM";
export const DELETE_LEAD_ITEM = "DELETE_LEAD_ITEM";
export const LEAD_CATEGORY_ADD_ITEM = "LEAD_CATEGORY_ADD_ITEM";
export const LEAD_CATEGORY_DELETE = "LEAD_CATEGORY_DELETE";
export const LEAD_CATEGORY_UPDATE = "LEAD_CATEGORY_UPDATE";
export const GET_ALL_LEAD_FAILED = "GET_ALL_LEAD_FAILED";